import Button from "@/components/Button";
import Input from "@/components/Input";
import { useEffect, useState } from "react";
import "./style.scss";
import { useLocation, useParams } from "react-router-dom";
import { BASE_URL, DROPDOWN_CATEGORY_PRODUCT_OPTIONS } from "@/utils/constant";
import getProductDetailInteractor from "@/@core/interactor/product/get-product-id";
import toast, { Toaster } from "react-hot-toast";
import setProductNumberInteractor from "@/@core/interactor/product/set-product-number";

const SetProductNumber = () => {
  const { id } = useParams();
  const [formInput, setFormInput] = useState({
    product_number: "",
    tag_uid: "",
  });

  const setProductNumber = async () => {
    try {
      const body = {
        tag_uid: formInput.tag_uid,
        product_number: parseInt(formInput.product_number),
      };
      await setProductNumberInteractor(body);

      toast.success(`${formInput.product_number} has been updated`);
    } catch (err) {
      if(err instanceof Error) {
        toast.error(err.message);
      }
      console.error(err);
    }
  };

  const onChangeInput = (e: any) => {
    const {
      target: { value, id },
    } = e;

    setFormInput({ ...formInput, [id]: value });
    console.log(formInput);
  };

  const onSaveAdd = async () => {
    try {
      await setProductNumber();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div className="product-form-page-wrapper">
        <div className="page-content">
          <div className="field-wrapper">
            <div className="left-section">
              <label>Product Number</label>
            </div>
            
            <div className="right-section">
              <Input
                style={{ width: "512px" }}
                id="product_number"
                value={formInput.product_number}
                onChange={onChangeInput}
                placeholder="Product Number"
              />
            </div>
          </div>

          <div className="field-wrapper">
            <div className="left-section">
              <label>Tag UID</label>
            </div>
            <div className="right-section">
              <Input
                style={{ width: "512px" }}
                id="tag_uid"
                value={formInput.tag_uid}
                onChange={onChangeInput}
                placeholder="Tag UID"
              />
            </div>
          </div>

          <div className="field-wrapper">
            <div className="left-section">
            </div>
            <div className="right-section">
            <Button
                label="Set"
                size="md"
                startIcon="save"
                onClick={onSaveAdd}
              />
            </div>
          </div>
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default SetProductNumber;
